import { Box, Grid, Stack, Typography } from "@mui/material";

import { LearningMedia } from "../../../lib/learning/contentContract";
import { resolveLearningMediaUrl } from "../../../lib/learning/mediaReference";
import { borderRadius, space } from "../../../theme/designTokens";

type GalleryBlockProps = {
  title: string;
  photos: Array<{ id: string; media: LearningMedia; caption?: string }>;
};

export const GalleryBlock = ({ title, photos }: GalleryBlockProps) => (
  <Stack spacing={space.xl}>
    <Typography component="h2" variant="h5">
      {title}
    </Typography>
    <Grid container spacing={space.xl}>
      {photos.map(photo => (
        <Grid item xs={12} md={photos.length === 1 ? 12 : 6} key={photo.id}>
          <Box component="figure" m={0}>
            <Box
              component="img"
              src={resolveLearningMediaUrl(photo.media.fn)}
              alt={photo.media.alt ?? ""}
              sx={{
                width: "100%",
                maxHeight: 520,
                objectFit: "cover",
                display: "block",
                borderRadius: borderRadius.md,
              }}
            />
            {photo.caption && (
              <Typography component="figcaption" color="text.secondary" mt={space.sm2}>
                {photo.caption}
              </Typography>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  </Stack>
);
